export enum PipelineType {
  Inbound = 'inbound',
  Outbound = 'outbound',
  Mixed = 'mixed',
}
